<template>
    <div class="sim_map">
        <p class="sim_map_undertitle">Спершу виберіть сектор погодніх даних в якому знаходяться Ваші поля</p>
        <div id="application-form-map" class="sim-form-map" style="height: 450px; position: relative; overflow: hidden;">
            <google-map
                :center="mapCenter"
                :zoom="zoom"
                map-type-id="hybrid"
                :options="{
                        mapTypeControl: false,
                        scaleControl: true,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: true,
                    }"
                style="width: 100%; height: 450px"
                ref="mapEl"
            >
            </google-map>
        </div>
        <div v-if="selectedMetePoint !== null" class="d-flex justify-content-between align-items-center application-form-map_text">
            <span class="">Центр сектору погодних даних: lat {{ mapCenter.lat }}, lon {{ mapCenter.lng }}</span>
            <button class="form_item_button" @click.prevent="resetSector">
                <span>Скинути обраний сектор</span>
            </button>
        </div>
    </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps';
export default {
    name: "MapComponent",

    mounted() {
        this.$refs.mapEl.$mapPromise.then((map) => {
            this.initMap(map);
        });

        this.mapCenter = this.center;
    },

    props: {
        center: Object,
        zoom: Number,
        meteoPoints: Array,
    },

    watch: {
        meteoPoints(val) {
            this.drawAllMeteoPoints(this.defaultMeteoPointOption);
            this.map.setZoom(7);
            this.selectedMetePoint = null;
            this.$emit('meteo-point-selected', null);
        },

        center(val) {
            this.mapCenter = val;
        }
    },

    data: function () {
        return {
            defaultMeteoPointColor:  '#5fa1b6',
            selectedMeteoPointColor: '#ff9301',
            map: null,
            meteoPointsData: null,
            selectedMetePoint: null,
            mapCenter: { lat: 49.26, lng: 32.03 },
        };
    },

    computed: {
        google: gmapApi,

        selectedMeteoPointOption: function() {
            return {strokeColor: this.selectedMeteoPointColor, fillColor: this.selectedMeteoPointColor};
        },

        defaultMeteoPointOption: function () {
            return { strokeColor: this.defaultMeteoPointColor, fillColor: this.defaultMeteoPointColor }
        },

        meteoPointStep: function () {
            return 0.04;
        }
    },

    methods: {
        initMap: function (map) {
            this.map = map;
        },

        drawAllMeteoPoints: function (polygonOptions, zIndex = 0) {
            if(this.meteoPointsData !== null) {
                this.meteoPointsData.forEach((meteoPoint) => {
                    if(meteoPoint.polygon) {
                        meteoPoint.polygon.setMap(null);
                    }
                });
            }

            this.meteoPointsData = this.meteoPoints;

            this.meteoPointsData.forEach((meteoPoint) => {
                this.drawMeteoPoint(meteoPoint, polygonOptions, true, zIndex);
            });
        },

        drawMeteoPoint: function (meteoPoint, polygonOptions, selectable, zIndex) {
            const { lat, lon } = meteoPoint;
            const square = this.getSector(lat, lon);

            let polygon = new this.google.maps.Polygon({
                paths: square,
                strokeOpacity: 0.9,
                strokeWeight: 1,
                fillOpacity: 0.2,
                point: meteoPoint,
                zIndex: zIndex,
            });

            meteoPoint.polygon = polygon;

            polygon.setOptions(polygonOptions);

            if(selectable) {
                this.google.maps.event.addListener(polygon, 'click', (e) => {
                    this.selectMeteoPoint(polygon.point);
                })
            }

            polygon.setMap(this.map);
        },

        getSector: function(lat, lng) {
            const NW = { lat: lat - this.meteoPointStep, lng: lng - this.meteoPointStep }
            const SW = { lat: lat - this.meteoPointStep, lng: lng + this.meteoPointStep }
            const SE = { lat: lat + this.meteoPointStep, lng: lng + this.meteoPointStep }
            const NE = { lat: lat + this.meteoPointStep, lng: lng - this.meteoPointStep }
            return [NW, SW, SE, NE]
        },

        selectMeteoPoint: function (point)
        {
            if(this.selectedMetePoint !== null) {
                this.selectedMetePoint.polygon.setOptions(this.defaultMeteoPointOption);
            }

            this.selectedMetePoint = point;
            this.mapCenter = {lat: point.lat, lng: point.lon};
            this.map.setCenter({lat: point.lat, lng: point.lon});
            this.map.setZoom(11);

            this.selectedMetePoint.polygon.setOptions(this.selectedMeteoPointOption);

            this.$emit('meteo-point-selected', point.id);
        },

        resetSector() {
            this.selectedMetePoint.polygon.setOptions(this.defaultMeteoPointOption);
            this.selectedMetePoint = null;
            this.map.setZoom(7);
            this.map.setCenter(this.center);
            this.$emit('meteo-point-selected', null);
        },
    }
}
</script>

<style scoped>

</style>
